export default __webpack_public_path__ + "static/WHE-2dad0d550ea500fe5f1c4a6d7b181594.svg";